import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useActiveOrg } from "context/ActiveOrgContext";
import { RegularButton } from "components/Button";
import ConfirmDialog from "components/ConfirmDialog";
import { deleteOrgAnimal } from "services/patients.service";
import vgToast from "utils/toast";

const DeletePatientButton = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { orgId } = useActiveOrg();
  const { getAccessTokenSilently } = useAuth0();
  const [open, setOpen] = React.useState(false);
  const [deleting, setDeleting] = React.useState(false);

  const animalId = id ? Number(id) : NaN;

  const handleDelete = async () => {
    if (orgId <= 0 || !Number.isFinite(animalId) || animalId <= 0) return;

    setDeleting(true);
    try {
      const token = await getAccessTokenSilently();
      const { error } = await deleteOrgAnimal(token, orgId, animalId);
      if (error) {
        vgToast.error(error.message);
        return;
      }
      setOpen(false);
      navigate("/app/patients");
    } catch (e) {
      vgToast.error((e as Error).message);
    } finally {
      setDeleting(false);
    }
  };

  return (
    <>
      <RegularButton
        color="Secondary"
        disabled={deleting}
        onClick={() => setOpen(true)}
      >
        <span>{deleting ? "Deleting…" : "Delete Patient"}</span>
      </RegularButton>

      <ConfirmDialog
        open={open}
        title="Delete patient?"
        description="This will permanently remove the patient record. This action cannot be undone."
        confirmLabel="Delete patient"
        busy={deleting}
        onCancel={() => {
          if (!deleting) setOpen(false);
        }}
        onConfirm={handleDelete}
      />
    </>
  );
};

export default DeletePatientButton;
